import { NavLink } from 'react-router-dom';
import React from 'react';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import { classNames } from 'helpers/style/classNames';
import useStyle from './navLink.style';
import { Icon } from '../../../atoms/Icons';
import palette from '../../../../theme/palette';

export interface NavLinkViewProps {
  handleClick: () => void;
  linkName: string;
  icon?: Icon;
  link: string;
  isExternal: boolean;
  isActiveLink: boolean;
  isOnBottomMenu?: boolean;
  isOnBurgerMenu?: boolean;
}

export const NavLinkView = ({
  handleClick,
  linkName,
  icon,
  link,
  isExternal,
  isActiveLink,
  isOnBottomMenu,
  isOnBurgerMenu
}: NavLinkViewProps) => {
  const classes = useStyle();
  return (
    <NavLink
      onClick={handleClick}
      to={isExternal ? { pathname: link } : link}
      target={isExternal ? '_blank' : ''}
      className={classNames(
        [classes.root],
        [
          {
            condition: !isOnBottomMenu && isActiveLink,
            classe: classes.active
          },
          {
            condition: isOnBurgerMenu,
            classe: classes.burgermenuroot
          }
        ]
      )}
    >
      {!isOnBottomMenu && !isOnBurgerMenu && (
        <>
          <FlatIcon
            icon={icon}
            color={isActiveLink && palette.common.white}
            size={'small'}
          />
          <p>{linkName}</p>
        </>
      )}
      {isOnBottomMenu && !isOnBurgerMenu && (
        <div
          className={`${classes.bottomMenuLink} ${isActiveLink &&
            classes.activeBottomMenuLink}`}
        >
          <FlatIcon icon={icon} />
        </div>
      )}
      {!isOnBottomMenu && isOnBurgerMenu && (
        <>
          <p className={classes.burgerMenuText}>{linkName}</p>
        </>
      )}
    </NavLink>
  );
};
